export enum SecondarySource {
  RECURLY = 'RECURLY',
  LEGACY = 'LEGACY',
  PORTAL = 'PORTAL',
  WEBSITE = 'WEBSITE',
  STUDIO = 'STUDIO',
  TESTCLOUD = 'TESTCLOUD',
  TESTOPS = 'TESTOPS',
  DIRECT_SALE = 'DIRECT_SALE',
}

export const TRIAL_SECONDARY_SOURCE = [
  SecondarySource.WEBSITE,
  SecondarySource.STUDIO,
  SecondarySource.TESTCLOUD,
];
